<template>
    <MainContainer>
        <div>
            <h2>
                Mitgliedsbeiträge verwalten
                <b-button
                    :size="size"
                    :to="{ path: '/fibu/mitgliedsbeitraege/verwalten/new' }"
                >
                    Neu
                    <font-awesome-icon icon="plus" />
                </b-button>
            </h2>
        </div>
        <Table
            bordered
            striped
            small
            showFilter
            tableClass="mitgliedsbeitraege-list"
            :responsive="true"
            :fields="fields"
            :items="items"
            :isBusy="busy"
            busyText="Lädt Mitgliedsbeiträge-Daten..."
            emptyText="Bisher wurden Mitgliedsbeiträge generiert..."
        >
            <template v-slot:head(id)></template>

            <template v-slot:head(status)></template>

            <template v-slot:head(text)></template>

            <template v-slot:head(beitrag)></template>

            <template v-slot:head(beitragspflicht)></template>

            <template v-slot:head(buchungskonto)></template>

            <template v-slot:id="{ row: row }">
                {{ row.item.id }}
            </template>

            <template v-slot:text="{ row: row }">
                {{ row.item.text }}
            </template>

            <template v-slot:beitrag="{ row: row }">
                {{ currency(row.item.beitrag) }}
            </template>


            <template v-slot:beitragspflicht="{ row: row }">
                <template v-if="row.item.beitragspflichtig === '1'">
                    <font-awesome-icon icon="check" />
                </template>
                <template v-else>
                    <font-awesome-icon icon="times" />
                </template>
            </template>

            <template v-slot:buchungskonto="{ row: row }">
                {{ row.item.buchungskonto !== null ? row.item.buchungskonto : '-'  }}
            </template>

            <template v-slot:actions="{ row: row }">
                <b-button
                    variant="link"
                    class="mv-table-action-btn mr-1"
                    :to="{ path: `/fibu/mitgliedsbeitraege/verwalten/${row.id}` }"
                >
                    bearbeiten
                </b-button>
                <b-button
                    :size="size"
                    @click="dataDelete(row)"
                    variant="link"
                    class="text-danger mv-table-action-btn"
                >
                    Löschen
                </b-button
                >
            </template>
        </Table>
        <RemoveModal
            :title="selected.title"
            :busy="selected.busy"
            @ok="dataProvide"
            @hide="dataHide"
        />
    </MainContainer>
</template>

<script>
import MainContainer from "@/components/MainContainer/MainContainer";
import {ApiFactory} from "@/api/ApiFactory";
import Table from "@/components/Table/Table";
import CommonView from "@/mixins/CommonView/CommonView";
import Validation from "@/mixins/Validation/Validation";
import Size from "@/mixins/Size/Size";
import RemoveModal from "@/components/RemoveModal/RemoveModal";
import Currency from "@/mixins/Currency/Currency";

const MitgliedsbeitraegeApi = ApiFactory.get('fiBuMitgliedsbeitraegeApi');

export default {
    name: 'FibuMitgliedsbeitraegeVerwaltung',
    mixins: [Validation, CommonView, Size, Currency],
    components: {
        MainContainer,
        Table,
        RemoveModal
    },
    data() {
        return {
            fields: [
                {
                    key: 'id',
                    label: 'ID',
                    class: 'text-left'
                },
                {
                    key: 'status',
                    label: 'Status Nr.',
                    class: 'text-left'
                },
                {
                    key: 'text',
                    label: 'Bezeichnung',
                    class: 'text-left'
                },
                {
                    key: 'beitrag',
                    label: 'Beitrag',
                    class: 'text-right'
                },
                {
                    key: 'beitragspflicht',
                    label: 'Beitragspflicht',
                    class: 'text-center'
                },
                {
                    key: 'buchungskonto',
                    label: 'Buchungskonto-Zuordnung',
                    class: 'text-left'
                },
                {
                    key: 'actions',
                    label: 'Funktionen',
                    class: 'text-left'
                },
            ],
            busy: false,
            items: [],
            api: MitgliedsbeitraegeApi
        }
    },
    created() {
        this.fetch();
    },
    methods: {
        async fetch() {
            this.busy = true;

            const response = await MitgliedsbeitraegeApi.getMitgliedsbeitraegeVerwaltung();

            if(response.ok) {
                this.registerRights(response);
                let items = response.json.collection;
                if(items) {
                    this.items = items;
                } else {
                    this.items = [];
                }
            }

            this.busy = false;
        }
    }
}
</script>

<style scoped>

</style>